<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;margin-top: 1rem;" class="fontMS700 font-45 colorPrincipal">
            INCA GARCILASO<br>
            DE LA VEGA
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio24/inca-garcilaso">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio24/inca-garcilaso">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio24/inca-garcilaso">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio24/GARCILAZO-000.jpg">
    
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24">
                    EL INCA GARCILASO DE LA VEGA ES CONSIDERADO DESDE HACE MUCHOS SIGLOS COMO UN CLÁSICO, 
                    EN LA MEDIDA QUE HA SIDO (RE) LEÍDO, ADMIRADO, CRITICADO, CUESTIONADO Y CONTROVERTIDO, 
                    Y PORQUE HA GENERADO —Y GENERA— UNA GRAN INFLUENCIA TANTO EN LA CONCEPCIÓN DE LA PERUANIDAD 
                    COMO EN LA VISIÓN HISTÓRICA DE NUESTRO PAÍS.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <img class="pd-10" width="100%"
                            src="/assets/images/micrositio/micrositio24/GARCILAZO-001.jpg">
                    </div>
                    <div class="col-sm-6">
                        <!--<p>
                            <br><br><br>
                        </p>-->
                        <p class="fontMS100 font-24">
                            <br>
                            Al mismo tiempo, a Garcilaso se le considera como un símbolo del Perú ya que, 
                            como señala Ricardo González Vigil, «en su experiencia vital y en sus obras encarna 
                            por primera vez —y de modo insuperado— la fusión de la tradición indígena y la cultura 
                            occidental». Del mismo modo, en Garcilaso en puede percibir un proyecto de nacionalidad 
                            peruana, tal como está expresado en el prólogo de la Historia general del Perú: «Prólogo 
                            a los indios, mestizos y criollos de los reinos y provincias del grande y riquísimo Imperio 
                            del Perú, el Inca Garcilaso de la Vega, su hermano, compatriota y paisano, salud y felicidad».
                        </p>
                        <p class="fontMS100 font-24">
                            <br>
                            En Garcilaso converge el narrador e historiador humanista, generador de utopías, lo que explica 
                            la prohibición de la lectura de los <span class="fontMS100Italic">Comentarios reales</span>, luego de la rebelión de Tupac Amaru, 
                            en el siglo XVIII, y su influencia en el proceso de la Emancipación peruana y la formulación 
                            de diversos planteamientos ideológicos que, incluso, fueron formulados en el siglo XX.
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <p class="fontMS100 font-24">
                        Por lo señalado, ofrecemos este espacio para (re)conocer a quien, según José Durand, es «sin duda el primer americano, 
                        al menos que se sepa, que tuvo sentimiento o conciencia o barrunto profundo de su nacionalidad».
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    LECTURAS FORMATIVAS,
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-40">
                            VISIÓN DEL MUNDO
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
                
                <p class="fontMS500 text-center font-24 text-white">
                    <br><br>
                    LA PRINCIPAL Y DIRECTA FUENTE DE INFORMACIÓN DEL INCA GARCILASO FUE «EL RECUERDO INDELEBLE DE LO QUE VIO 
                    Y OYÓ EN SUS AÑOS DEL CUZCO, LO QUE PRESTA UN RELIEVE EXCEPCIONAL Y UNA EXTRAORDINARIA CAPACIDAD DE ANIMACIÓN 
                    A SU OBRA HISTÓRICA». ES ASÍ QUE, POR EJEMPLO, EN <span class="fontMS500Italic">LA FLORIDA DEL INCA</span> DICE LO SIGUIENTE: «DIRÉ DE LOS INCAS... -HABÍA 
                    ANUNCIADO EN LA FLORIDA- LO QUE A MI MADRE Y A SUS TÍOS Y PARIENTES ANCIANOS Y A TODA LA DEMÁS GENTE DE LA PATRIA LES OÍ 
                    Y LO QUE YO DE AQUELLA ANTIGÜEDAD ALCANCÉ A VER».
                    <br><br>
                </p>
                <p class="fontMS100 text-justify font-24 text-white">
                    Del mismo modo, solicitó información a sus conocidos en el Cusco y leyó críticamente a muchos cronistas como Pedro Cieza de León, 
                    José de Acosta, Agustín de Zárate, Francisco López de Gómara y, principalmente, Blas Valera. Destacan, por ejemplo, las anotaciones 
                    realizadas en <span class="fontMS100Italic">La historia general de las Indias</span>, de López de Gómara, valioso ejemplar custodiado en la Biblioteca Nacional del Perú.
                    <br><br>
                </p>
                <p class="fontMS100 text-justify font-24 text-white">
                    Por otro lado, Garcilaso es considerado como «el primer gran humanista, además, nacido en tierra americana» (José Durand), en la medida 
                    que fue sustancial la formación de Garcilaso dentro del humanismo y la dedicación en «la traducción y su conciencia del papel de lo 
                    lingüístico en el conocimiento y conformación de un pueblo, vinculando agudamente lengua, sociedad e historia». Por tal motivo, no fue 
                    casual su interés por el estudio de los vocabularios y catecismos ni tampoco el que su primera obra fuese la traducción al castellano de 
                    los <span class="fontMS100Italic">Diálogos del amor</span> de León Hebreo (1590).
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-12 libro">
                        <img width="100%" height="100%"
                            src="/assets/images/micrositio/micrositio24/GARCILAZO-002.jpg">
                    </div>
                </div>
                
            </div>
        </div>
        <div class="row bottom_cel mt-3">
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/12967" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-003.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">León Hebreo<br></span>
                            <span class="fontMS100">
                                Dialogi d'amore di maestro Leone Medico Hebreo. 
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/46526" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-004.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">Francisco López de Gomara.<br></span>
                            <span class="fontMS100">
                                La historia general de las Indias y nuevo mundo
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/13879" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-005.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">Piedro de Cieza de León. <br></span>
                            <span class="fontMS100">
                                La Chronica del Peru, nuevamente escrita.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/69704" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-006.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">Anómino. <br></span>
                            <span class="fontMS100">
                                Arte, y vocabulario en la lengua
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/12946" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-007.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">Diego González Holguín. <br></span>
                            <span class="fontMS100">
                                Vocabvlario de la Lengva General de todo el Perv llamada lengua Qquichua, 
                                o del Inca.<br> 
                                Francisco del Canto, 1608.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
        <!--RESPONSIVE-->
        <div class="row c100">
            <div class="col-sm-2 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/12967" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-003.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">León Hebreo<br></span>
                            <span class="fontMS100">
                                Dialogi d'amore di maestro Leone Medico Hebreo. 
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/46526" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-004.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">Francisco López de Gomara.<br></span>
                            <span class="fontMS100">
                                La historia general de las Indias y nuevo mundo
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79303" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-005.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">Piedro de Cieza de León. <br></span>
                            <span class="fontMS100">
                                La Chronica del Peru, nuevamente escrita.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/69704" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-006.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">Anómino. <br></span>
                            <span class="fontMS100">
                                Arte, y vocabulario en la lengua
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-2 libro mt-3">
                <a href="https://hdl.handle.net/20.500.14428/12946" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-007.jpg">
                    <div class="overlay-img4">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">Diego González Holguín. <br></span>
                            <span class="fontMS100">
                                Vocabvlario de la Lengva General de todo el Perv llamada lengua Qquichua, 
                                o del Inca.<br> 
                                Francisco del Canto, 1608.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="c100">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio24/E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-5">
                        <p style="line-height: 130%;margin-bottom: 0%;margin-top:5%" class="fontMS700 colorPrincipal font-40">
                            ENTRE DOS MUNDOS:
                        </p>
                    </div>
                    <div class="col-sm-7">
                        <img class="LineSubsec_Izq bottom_cel" width="100%" style="margin-top: 7%;"
                            src="/assets/images/micrositio/micrositio24/E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS100 colorPrincipal font-40">
                    EL INCA GARCILASO DE LA VEGA EN ESPAÑA
                </p>
                <div class="c100">
                    <img class="LineSubsec_Izq" width="100%"
                        src="/assets/images/micrositio/micrositio24/E03-MS08-GRAMA_LINEA1-recortada2.png">
                </div>
                <p class="fontMS500 text-center font-24">
                    <br><br>
                    EL INCA GARCILASO DE LA VEGA NACIÓ EN UNA ÉPOCA DE TRANSFORMACIONES RADICALES EN SU TIERRA NATAL 
                    Y ASIMILÓ CON BRILLANTEZ Y ORIGINALIDAD LAS DIVERSAS EXPRESIONES FILOSÓFICAS, LITERARIAS Y ARTÍSTICAS 
                    DE SU TIEMPO (HUMANISMO, RENACIMIENTO, CONTRARREFORMA, BARROCO) CARACTERIZADO POR LOS IMPERIOS DE 
                    ULTRAMAR Y LA EXPANSIÓN COMERCIAL.
                    <br><br>
                </p>

                <div class="row">
                    <div class="col-sm-6">
                        <img class="pd-10" width="100%"
                            src="/assets/images/micrositio/micrositio24/GARCILAZO-008.jpg">
                    </div>
                    <div class="col-sm-6">
                        <p class="bottom_cel">
                            <br><br><br><br>
                        </p>
                        <p class="fontMS100 font-24 text-gris">
                            <br>
                            El Inca Garcilaso de la Vega encarnó, tanto en su vida como en sus obras, 
                            la fusión de la tradición indígena y la cultura occidental. Por tal razón, 
                            José de la Riva Agüero sostiene que es «la personificación más alta y acabada 
                            de la índole literaria del Perú, que logró desde el principio en este su primogénito 
                            un admirable y fidelísimo intérprete, y que ha continuado luego manifestándose, aunque 
                            con menos lucimiento, en las épocas posteriores. Todo en el Inca Garcilaso, desde su 
                            sangre, su carácter y las circunstancias de su vida, hasta la materia de sus escritos, 
                            y las dotes de imaginación y el inconfundible estilo con que los embelleció, concurre 
                            a hacerlo representativo perfecto, adecuado símbolo del alma de nuestra tierra».
                            <br><br><br>
                        </p>
                        <p class="fontMS100Italic font-22 text-gris" style="font-weight: bold;">
                            The Siege of Cuzco, The Royal<br>
                            Commentaries, p. 583
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p>
                            <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA FLORIDA DEL INCA
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>

                <p class="fontMS500 text-center font-24">
                    <br><br>
                    INTERESADO EL INCA GARCILASO DE LA VEGA EN NO DEJAR EN EL OLVIDO
                    GRANDES HAZAÑAS DE LOS ESPAÑOLES E INDIOS, RECOGE LOS TESTIMONIOS
                    DE SOLDADOS QUE PARTICIPARON CON HERNANDO DE SOTO EN LA
                    CONQUISTA DE TERRITORIO NORTEAMERICANO: GONZALO SILVESTRE, JUAN
                    COLES Y ALONSO DE CARMONA. AL PROVENIR ÉL DE LA RAZA INDIA Y DE LA
                    ESPAÑOLA EXALTA A AMBAS CULTURAS, AL NO HABER SIDO TESTIGO, RECURRE
                    EN OCASIONES A LA FICCIÓN.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4"></div>
                    <div class="col-sm-4 libro">
                        <a href="https://hdl.handle.net/20.500.14428/12834" target="_blank" style="color: black;">
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio24/GARCILAZO-009.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">Inca Garcilaso de la Vega. <br></span>
                                    <span class="fontMS100">
                                        La Florida del Inca : historia del Adelantado Hernando de Soto 
                                        Madrid: Oficina Real, a costa de Nicolas Rodriguez Franco, 1723 (reimpresión).
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4"></div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p>
                            <img width="100%" src="/assets/images/micrositio/micrositio4/ET03_MS07_EDU_LINEA2.jpg">
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LOS COMENTARIOS REALES
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>

                <p class="fontMS500 text-center font-24">
                    <br><br>
                    AURELIO MIRÓ QUESADA SOSA DEFINE A LA PRIMERA PARTE DE ESTA OBRA DE LA SIGUIENTE FORMA: 
                    «OBRA DE RECONSTRUCCIÓN DEL IMPERIO DE LOS INCAS Y EVIDENTE HOMENAJE A SU SANGRE INDÍGENA MATERNA, 
                    LOS COMENTARIOS REALES ALTERNAN LA RELACIÓN DE LAS CONQUISTAS CON LA PRESENTACIÓN DE LAS LEYES, LOS 
                    RITOS Y LOS MITOS, LAS INSTITUCIONES, EL GOBIERNO, LAS ARTES, LAS COSTUMBRES Y LA DESCRIPCIÓN DE LOS 
                    PRODUCTOS DE LOS TRES REINOS NATURALES»
                    <br><br>
                </p>

                <p class="fontMS100 text-justify font-24 text-gris">
                    La segunda parte de los <span class="fontMS100Italic">Comentarios Reales de los Incas</span> abarca cuarenta años de historia (1532 a 1572). 
                    El autor se considera testigo de vista a diferencia de otros cronistas; recoge los
                    testimonios de sus parientes indios y de los protagonistas de esos hechos históricos. Reivindica a
                    los conquistadores olvidados por la corona a pesar de haber ganado territorios y riquezas para
                    España, específicamente a su padre, a quien se le consideraba traidor por haber ayudado a
                    escapar al rebelde Gonzalo Pizarro.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6 mt-3 libro">
                        <a href="https://hdl.handle.net/20.500.14428/16266" target="_blank" style="color: black;">
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio24/GARCILAZO-010.jpg">
                            <div class="overlay-img2">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">Inca Garcilaso de la Vega. <br></span>
                                    <span class="fontMS100">
                                        Primera parte de los commentarios reales.<br>
                                        Lisboa: Officina de Pedro Crasbeeck, 1609.
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 mt-3 libro">
                        <a href="https://hdl.handle.net/20.500.14428/13898" target="_blank" style="color: black;">
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio24/GARCILAZO-011.jpg">
                            <div class="overlay-img2">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">Inca Garcilaso de la Vega. <br></span>
                                    <span class="fontMS100">
                                        Historia general del Perú. <br>
                                        Córdoba: por la viuda de Andrés de Barrera, 1616.
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="\assets\images\general\LINEA_RESALTE_BLANCA.png" width="100%">
            </div>
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24 mt-3 text-white">
                    <br><br>
                    DEMÁS DE ESTO, EN TODO LO QUE DE ESTA REPÚBLICA, ANTES DESTRUIDA QUE CONOCIDA, DIJERE, 
                    SERÁ CONTANDO LLANAMENTE LO QUE EN SU ANTIGÜEDAD TUVO DE SU IDOLATRÍA, RITOS, SACRIFICIOS 
                    Y CEREMONIAS, Y EN SU GOBIERNO, LEYES Y COSTUMBRES, EN PAZ Y EN GUERRA, SIN COMPARAR COSA 
                    ALGUNA DE ESTAS A OTROS SEMEJANTES QUE EN LAS HISTORIAS DIVINAS Y HUMANAS SE HALLAN, NI AL 
                    GOBIERNO DE NUESTROS TIEMPOS, PORQUE TODA COMPARACIÓN ES ODIOSA.
                </p>
            </div>
            <div class="col-sm-12 text-right mt-3 mb-3 text-white">
                <span class="fontMS500Italic font-24">
                    INCA GARCILASO DE LA VEGA<br>
                    CAPÍTULO XIX ("PROTESTACIÓN DEL AUTOR SOBRE LA HISTORIA") DEL LIBRO I DE LOS COMENTARIOS REALES DE LOS INCAS".<br>
                </span>
            </div>
            <div class="col-sm-12">
                <img src="\assets\images\general\LINEA_RESALTE_BLANCA.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>



<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            TRASCENDENCIA UNIVERSAL
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24">
                            DURANTE MUCHOS AÑOS SE SOSTUVO QUE EL INCA GARCILASO DE LA VEGA, MIGUEL DE CERVANTES Y 
                            WILLIAM SHAKESPEARE, TRES DE LAS FIGURAS TRASCENDENTALES PARA LA LITERATURA OCCIDENTAL, 
                            TANTO EN CASTELLANO COMO EN  INGLÉS, FALLECIERON EL MISMO DÍA: 23 DE ABRIL DE 1616. 
                            SIN EMBARGO, INVESTIGACIONES POSTERIORES HAN DEMOSTRADO QUE LAS FECHAS DE LOS DECESOS 
                            DE DICHOS PERSONAJES ILUSTRES  FUERON APROXIMADAS.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24 text-gris">
                            Dicha fecha «simbólica» para la literatura universal dio origen a la conmemoración del Día 
                            Internacional del Libro destinada a «rendir un homenaje universal a los libros y autores 
                            en esta fecha, alentando a todos, y en particular a los jóvenes, a descubrir el placer de 
                            la lectura». 
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24 text-gris">
                            Al margen de este equívoco, es importante destacar que los textos de Shakespeare y Cervantes 
                            han sido traducidos a múltiples lenguas,  versionados y analizados en innumerables ocasiones. 
                            Su influencia es tal que son figuras imprescindibles en la cultura española e inglesa. 
                            Del mismo modo, las obras del Inca Garcilaso de la Vega, por su parte, tienen un enorme 
                            significado para los peruanos porque representan una parte de nuestra historia.
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <img width="100%"
                            src="/assets/images/micrositio/micrositio24/GARCILAZO-012.jpg">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="c100">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio24/E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;margin-top:5%" class="fontMS700 colorPrincipal font-40">
                            TRADUCCIONES,
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img class="LineSubsec_Izq bottom_cel" width="100%" style="margin-top: 5%;"
                            src="/assets/images/micrositio/micrositio24/E03-MS08-GRAMA_LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS100 colorPrincipal font-40">
                    REIMPRESIONES Y PROHIBICIONES
                </p>
                <div class="c100">
                    <img class="LineSubsec_Izq" width="100%"
                        src="/assets/images/micrositio/micrositio24/E03-MS08-GRAMA_LINEA1-recortada2.png">
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24">
                            <br><br>
                            DESDE EL SIGLO XVI, LAS OBRAS DEL INCA GARCILASO DE LA VEGA HAN SIDO TRADUCIDAS
                            A DIVERSAS LENGUAS (INGLÉS, FRANCÉS, ALEMÁN, FLAMENCO, ETC).
                            <br><br>
                        </p>
                        <p class="fontMS100 font-24 text-gris text-justify">
                            Ejerció influencia en el proceso de emancipación de finales del siglo XVIII y comienzos del 
                            siglo XIX: la rebelión de Tupac Amaru, la Carta a los españoles americanos de Viscardo y Guzmán,
                            y la disposición de José de San Martín de editar y difundir los <span class="fontMS100Italic">Comentarios reales</span>. 
                            Sin embargo, en 1782, este libro fue prohibido por la administración española por ser incitador 
                            y por promover el sentimiento de nacionalidad. Al respecto, Luis E. Valcárcel sostiene que
                             Garcilaso fue «el creador de la patria peruana. Sin Garcilaso no tendríamos una base literaria
                              e histórica para hablar de la patria peruana desde tiempos lejanos».
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-6 libro">
                        <!--<p class="bottom_cel">
                            <br><br><br><br><br><br><br>
                        </p>-->
                        <p class="bottom_cel">
                            <br><br>
                        </p>
                        <a href="https://hdl.handle.net/20.500.14428/13908" target="_blank" style="color: black;">
                            <img class="pi-10" width="100%"
                                    src="/assets/images/micrositio/micrositio24/GARCILAZO-013.jpg">
                            <div class="overlay-img3">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">Inca Garcilaso de la Vega. <br></span>
                                    <span class="fontMS100">
                                        Histoire des gverres civiles des espagnols dans les indes.<br>
                                        París: Simeon Piget, 1658
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/13897" target="_blank" style="color: black;">
                            <img width="100%"
                            src="/assets/images/micrositio/micrositio24/GARCILAZO-014.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">Inca Garcilaso de la Vega. <br></span>
                                    <span class="fontMS100">
                                        The royal commentaries of Peru. <br>
                                        London: Miles Flesher, for Jacob Tonson, 1688. 
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/12754" target="_blank" style="color: black;">
                            <img width="100%"
                            src="/assets/images/micrositio/micrositio24/GARCILAZO-015.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">Inca Garcilaso de la Vega. <br></span>
                                    <span class="fontMS100">
                                        Histoire des Yncas, rois du Perou   <br>
                                        Amsterdam: Jaques Desbordes, 1715 
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-3">
                        <a href="https://hdl.handle.net/20.500.14428/13899" target="_blank" style="color: black;">
                            <img width="100%"
                            src="/assets/images/micrositio/micrositio24/GARCILAZO-016.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">Inca Garcilaso de la Vega. <br></span>
                                    <span class="fontMS100">
                                        Historia general del Perú<br>
                                        Madrid: En la Oficina Real y à Costa de Nicolás Rodríguez Franco, 1722 (reimpresión) 
                                    </span>
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL LEGADO
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS100 text-center colorPrincipal font-40">
                    DEL INCA GARCILASO
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-center font-24 text-white">
                            NUNCA SE HA NEGADO LA IMPORTANCIA DE LA OBRA DEL INCA GARCILASO,
                            PERO LAS APRECIACIONES HAN CAMBIADO A LO LARGO DEL TIEMPO. SIRVIÓ DE
                            FUENTE PARA LOS ESCRITORES DEL SIGLO XIX, PERO SE HA CUESTIONADO LA
                            PARCIALIDAD DE SU PRESENTACIÓN DE LOS HECHOS. DESDE INICIOS DEL SIGLO
                            XX, SE RECONOCE POR SU VALOR LITERARIO Y SE CONVIRTIÓ EN PRECURSOR
                            DEL INDIGENISMO LITERARIO.
                            <br><br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row bottom_cel mt-3">
            <div class="col libro">
                <a href="https://bvpb.mcu.es/es/catalogo_imagenes/grupo.do?path=175110" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-017.jpg">
                    <div class="overlay-img5">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Mariano Eduardo de Rivero y Juan Diego de Tschudi. 
                            </span>
                            <span class="fontMS100">
                                Antigüedades peruanas.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a href="https://hdl.handle.net/20.500.14428/63326" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-018.jpg">
                    <div class="overlay-img5">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                William Hickling Prescott.  
                            </span>
                            <span class="fontMS100">
                                Historia de la conquista del Perú : precedida de una ojeada sobre la civilización de los Incas
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a [routerLink]="['/ficha/ART-114']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-019.jpg">
                    <div class="overlay-img5">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                José de la Riva-Agüero.   
                            </span>
                            <span class="fontMS100">
                                Elogio del Inca Garcilaso por el Catedrático doctor José de la Riva Agüero. 
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col libro">
                <a href="http://hdl.handle.net/20.500.14428/79178" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-020.jpg">
                    <div class="overlay-img5">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada.   
                            </span>
                            <span class="fontMS100">
                                Baladas peruanas.<br>
                                Santiago de Chile : Ed. Ercilla, 1935.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
        <!--RESPONSIVE-->
        <div class="row c100">
            <div class="col-sm-3 libro mt-3">
                <a target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-017.jpg">
                    <div class="overlay-img5">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Mariano Eduardo de Rivero y Juan Diego de Tschudi. 
                            </span>
                            <span class="fontMS100">
                                Antigüedades peruanas.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro mt-3">
                <a [routerLink]="['/ficha/LIB-3006']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-018.jpg">
                    <div class="overlay-img5">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                William Hickling Prescott.  
                            </span>
                            <span class="fontMS100">
                                Historia de la conquista del Perú : precedida de una ojeada sobre la civilización de los Incas
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro mt-3">
                <a [routerLink]="['/ficha/ART-114']" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-019.jpg">
                    <div class="overlay-img5">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                José de la Riva-Agüero.   
                            </span>
                            <span class="fontMS100">
                                Elogio del Inca Garcilaso por el Catedrático doctor José de la Riva Agüero. 
                            </span>
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-sm-3 libro mt-3">
                <a href="http://hdl.handle.net/20.500.14428/79178" target="_blank" style="color: black;">
                    <img width="100%" height="100%"
                    src="/assets/images/micrositio/micrositio24/GARCILAZO-020.jpg">
                    <div class="overlay-img5">
                        <p class="fontMS100 text-center">
                            <span class="fontMS500">
                                Manuel González Prada.   
                            </span>
                            <span class="fontMS100">
                                Baladas peruanas.<br>
                                Santiago de Chile : Ed. Ercilla, 1935.
                            </span>
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>



<div class="fondoOrange">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <img width="100%" class="pd-10"
                            src="/assets/images/micrositio/micrositio24/GARCILAZO-021.jpg">
                    </div>
                    <div class="col-sm-6">
                        <p class="bottom_cel">
                            <br><br>
                        </p>
                        <p class="fontMS100 text-white font-24">
                            <br>
                            Diversos autores consideran que, en los tiempos actuales de intolerancia 
                            y exclusiones, la obra del Inca Garcilaso de la Vega es profundamente humanista. 
                            En ese contexto, planteamos las siguientes interrogantes:
                        </p>
                        <p class="bottom_cel">
                            <br><br><br><br><br><br>
                        </p>
                        <p class="fontMS100Italic font-22 text-white" style="font-weight: bold;">
                            José Sabogal.<br>
                            Garcilaso de la Vega. <br>
                            Óleo sobre tela, 1949.
                        </p>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="row mt-4">
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿La lectura de los <span class="fontMS500Italic">Comentarios Reales</span> puede ayudar a imaginar un proyecto de vida social 
                                en común?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Qué opinas del siguiente comentario de Carlos Iván Degregori: «Hace cuatro siglos, el 
                                Inca Garcilaso trató de ser mediador de un diálogo imposible, pero obligatorio, pues sin 
                                tal diálogo… no podía sobrevivir»? 
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Cuáles son las nuevas lecturas que podrían motivar la obra del Inca Garcilaso?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                        <div class="col-sm-4">
                            <img class="bottom_cel" width="100%"
                                    src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio24\E03-MS08-GRAMA_LINEA1-recortada3.png">
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <p class="font-24 text-gris">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Chang-Rodríguez, R. (ed.) (2006).</span>
                    <span class="fontMS100Italic text-gris">
                        Franqueando fronteras. Garcilaso de la Vega y «La Florida del Inca».
                    </span>
                    <span class="text-gris">
                        Lima, Fondo Editorial de la  Pontificia Universidad Católica del Perú. <br>
                    </span>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Durand, J. (1998).
                    </span>
                    <span class="fontMS100Italic text-gris">
                        El Inca Garcilaso de América.
                    </span>
                    <span class="text-gris">Lima, Biblioteca Nacional del Perú.<br></span>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Fernández, C. (2004).</span>
                    <span class="fontMS100Italic text-gris">
                        Inca Garcilaso de la Vega: Imaginación, memoria e identidad.
                    </span>
                    <span class="text-gris">Lima, Universidad Nacional Mayor de San Marcos.<br></span>
                </p>
                <p class="font-24">
                    <span class="fontMS500">González Vigil, R. (1989).</span>
                    <span class="fontMS100Italic text-gris">
                        Comentemos al Inca Garcilaso.
                    </span>
                    <span class="text-gris">Lima: Banco Central de Reserva, Fondo Editorial. <br></span>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="font-24">
                    <span class="fontMS500">Hernández, M. (1993). </span>
                    <span class="fontMS100Italic text-gris">Memoria del bien perdido; conflicto, identidad, nostalgia en el Inca Garcilaso de la Vega.
                    </span>
                    <span class="text-gris">
                        Lima, Instituto de Estudios Peruanos.<br>
                    </span>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Mazzotti, J. (1996). </span>
                    <span class="fontMS100Italic text-gris">Coros mestizos del Inca Garcilaso. Resonancias andinas.
                    </span>
                    <span class="text-gris">
                        Lima, Fondo de Cultura Económica.<br>
                    </span>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Miró Quesada, A. (1994). </span>
                    <span class="fontMS100Italic text-gris">El Inca Garcilaso.
                    </span>
                    <span class="text-gris">
                        Lima, Pontificia Universidad Católica del Perú.<br>
                    </span>
                </p>
                <p class="font-24">
                    <span class="fontMS500">Riva Agüero, J. (1962). </span>
                    <span class="fontMS100Italic text-gris">Del Inca Garcilaso a Eguren. 
                    </span>
                    <span class="text-gris">
                        Lima, Pontificia Universidad Católica del Perú.<br>
                    </span>
                </p>
                
            </div>
        </div>
    </div>
</div>
<!-- Footer -->
